var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relatorio-card-container"},[_c('div',{staticClass:"infos"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))])]),_c('Button',{attrs:{"text":"Gerar","color":"primary"},on:{"handle:click":_vm.onAction}},[_c('DownloadOutline',{attrs:{"size":18}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }